/**
 * @generated SignedSource<<bb0ea57aabbca57cea04c84de7dc1f7d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type damDialogPaginationQuery$variables = {
  count?: number | null;
  cursor?: string | null;
  filterMasks?: string | null;
  sortBy?: string | null;
  title?: string | null;
};
export type damDialogPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"damDialog_fragment">;
};
export type damDialogPaginationQuery = {
  response: damDialogPaginationQuery$data;
  variables: damDialogPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": 20,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": "0",
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": "",
    "kind": "LocalArgument",
    "name": "filterMasks"
  },
  {
    "defaultValue": "",
    "kind": "LocalArgument",
    "name": "sortBy"
  },
  {
    "defaultValue": "",
    "kind": "LocalArgument",
    "name": "title"
  }
],
v1 = {
  "kind": "Variable",
  "name": "filterMasks",
  "variableName": "filterMasks"
},
v2 = {
  "kind": "Variable",
  "name": "sortBy",
  "variableName": "sortBy"
},
v3 = {
  "kind": "Variable",
  "name": "title",
  "variableName": "title"
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v2/*: any*/),
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "damDialogPaginationQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "damDialog_fragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "damDialogPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "DamScenesConnection",
        "kind": "LinkedField",
        "name": "damScenes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DamScenesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DamScene",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DamScenesAssets",
                    "kind": "LinkedField",
                    "name": "assets",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "roles",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DamSceneAsset",
                        "kind": "LinkedField",
                        "name": "asset",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "assetType",
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DamSceneAssetFile",
                            "kind": "LinkedField",
                            "name": "file",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "fileUrl",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "thumbnailUrl",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "filters": [
          "title",
          "filterMasks",
          "sortBy"
        ],
        "handle": "connection",
        "key": "damDialog_damScenes",
        "kind": "LinkedHandle",
        "name": "damScenes"
      }
    ]
  },
  "params": {
    "cacheID": "ab33207d7a4ffe039e0dc3ba62c16453",
    "id": null,
    "metadata": {},
    "name": "damDialogPaginationQuery",
    "operationKind": "query",
    "text": "query damDialogPaginationQuery(\n  $count: Int = 20\n  $cursor: String = \"0\"\n  $filterMasks: String = \"\"\n  $sortBy: String = \"\"\n  $title: String = \"\"\n) {\n  ...damDialog_fragment_1iLlzO\n}\n\nfragment damDialog_fragment_1iLlzO on Query {\n  damScenes(first: $count, after: $cursor, title: $title, filterMasks: $filterMasks, sortBy: $sortBy) {\n    edges {\n      node {\n        id\n        title\n        assets {\n          roles\n          asset {\n            assetType\n            title\n            file {\n              fileUrl\n            }\n            thumbnailUrl\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "64adde6885b1f91c3fc7eeb5e4ddf1bd";

export default node;
